import { ChatHistoryType } from '@/types/converse/chatHistory'; // adjust import path as needed
import { Box, Button } from '@mui/material';
import { GridColDef, GridToolbar } from '@mui/x-data-grid';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { useNavigate } from 'raviger';

interface CallsListProps {
  calls: ChatHistoryType[];
  loading?: boolean;
  onTranscriptClick: (id: string, forceOpen?: boolean) => void;
}

function CallsList({
  calls: conversations,
  onTranscriptClick,
  loading = false,
}: CallsListProps) {
  const navigate = useNavigate();

  // Format date to a readable format
  const formatDate = (dateString: Date): string => {
    return new Date(dateString).toLocaleString();
  };

  const columns: GridColDef[] = [
    {
      field: 'phone',
      headerName: 'Caller',
      flex: 0.5,
    },
    {
      field: 'title',
      headerName: 'Receiver',
      flex: 0.5,
      valueFormatter: (params: string) => {
        console.log('Received value at Receiver valueFormatter = ');
        console.log(params);
        const segment = params.split('-')[1] ?? '';
        const numbers = segment.split(':').map((s: string) => s.trim());
        return numbers.pop() ?? 'NA';
      },
    },
    // {
    //   field: 'title',
    //   headerName: 'Title',
    //   flex: 1,
    // },
    // {
    //   field: 'username',
    //   headerName: 'Username',
    //   flex: 0.5,
    // },
    {
      field: 'createdAt',
      headerName: 'Created At',
      flex: 0.8,
      valueFormatter: (params: string) => formatDate(new Date(params)),
    },
    {
      field: 'messages',
      headerName: 'Conversation Length',
      flex: 0.5,
      valueGetter: (params: any[]) => (params ?? []).length.toString(), // Dummy duration
    },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 0.8,
      renderCell: (params) => (
        <Button
          variant="outlined"
          size="small"
          onClick={() => {
            console.log('Row Params = ');
            console.log(params.row);
            // Pass true as second parameter to force open the side sheet
            onTranscriptClick(params.row.id, true);
          }}
        >
          Show Transcript
        </Button>
      ),
    },
  ];

  return (
    <Box style={{ height: '40vh', width: '100%' }}>
      <DataGridPro
        slots={{ toolbar: GridToolbar }}
        slotProps={{
          toolbar: {
            showQuickFilter: true,
          },
        }}
        rows={conversations}
        columns={columns}
        loading={loading}
        getRowId={(row) => row._id ?? crypto.randomUUID()}
        pageSizeOptions={[5, 10, 25]}
        initialState={{
          pagination: {
            paginationModel: { pageSize: 10 },
          },
        }}
      />
    </Box>
  );
}

export default CallsList;
